/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: 'capitalize'})
export class CapitalizePipe implements PipeTransform {
  
  transform(value: string): string {
    return value != null? value.split(' ').map(
      function(word: string): string {
        return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
      }
    ).join(' ') : '';
  }
  
}
